import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ProductDetailsModal = ({ isOpen, onClose, product, onEdit }) => {
  if (!isOpen || !product) return null;

  const getStatusColor = (status) => {
    switch (status) {
      case 'active':
        return 'bg-success text-success-foreground';
      case 'inactive':
        return 'bg-secondary text-secondary-foreground';
      // case 'out_of_stock':
      //   return 'bg-error text-error-foreground';
      // case 'draft':
      //   return 'bg-warning text-warning-foreground';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'active':
        return 'Active';
      case 'inactive':
        return 'Inactive';
      case 'out_of_stock':
        return 'Out of Stock';
      case 'draft':
        return 'Draft';
      default:
        return 'Unknown';
    }
  };

  const getInventoryStatus = (quantity) => {
    if (quantity === 0) return { color: 'text-error', text: 'Out of Stock', icon: 'AlertTriangle' };
    if (quantity <= 10) return { color: 'text-warning', text: 'Low Stock', icon: 'AlertCircle' };
    return { color: 'text-success', text: 'In Stock', icon: 'CheckCircle' };
  };

  const inventoryStatus = getInventoryStatus(product.inventory);
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <div className="fixed inset-0 z-1200 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen p-4">
        <div className="fixed inset-0 bg-black/50" onClick={onClose} />
        
        <div className="relative bg-card border border-border rounded-lg w-full max-w-4xl max-h-[90vh] overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-border">
            <div className="flex items-center space-x-3">
              <Icon name="Package" size={24} className="text-primary" />
              <h2 className="text-xl font-semibold text-foreground">
                Product Details
              </h2>
            </div>
            <Button
              variant="ghost"
              size="icon"
              onClick={onClose}
              className="micro-animation"
            >
              <Icon name="X" size={20} />
            </Button>
          </div>

          {/* Content */}
          <div className="overflow-y-auto max-h-[calc(90vh-140px)]">
            <div className="p-6">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                {/* Left Column - Image and Basic Info */}
                <div className="space-y-6">
                  {/* Product Image */}
                  <div className="relative">
                    {/* <div className="w-full h-80 overflow-hidden rounded-lg bg-muted">
                      <Image
                        src={product.image}
                        alt={product.name}
                        className="w-full h-full object-cover"
                      />
                    </div> */}
                    
                    {/* Status Badge */}
                    <div className={`absolute top-4 right-4 px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(product.status)}`}>
                      {getStatusText(product.status)}
                    </div>

                    {/* Featured Badge */}
                    {product.featured && (
                      <div className="absolute top-4 left-4 bg-accent text-accent-foreground px-3 py-1 rounded-full text-sm font-medium flex items-center space-x-1">
                        <Icon name="Star" size={14} />
                        <span>Featured</span>
                      </div>
                    )}
                  </div>

                  {/* Basic Information */}
                  <div className="space-y-4">
                    <div>
                      <h3 className="text-2xl font-bold text-foreground mb-2">
                        {product.name}
                      </h3>
                      {/* <p className="text-muted-foreground">
                        {product.description || 'No description available'}
                      </p> */}
                    </div>

                    {/* Category and SKU */}
                    <div className="flex items-center space-x-6">
                      <div className="flex items-center space-x-2">
                        <Icon name="Tag" size={16} className="text-muted-foreground" />
                        <span className="text-sm text-muted-foreground">Category:</span>
                        <span className="text-sm font-medium text-foreground capitalize">
                          {product.category?.replace('_', ' ')}
                        </span>
                      </div>
                      
                      {/* <div className="flex items-center space-x-2">
                        <Icon name="Hash" size={16} className="text-muted-foreground" />
                        <span className="text-sm text-muted-foreground">SKU:</span>
                        <span className="text-sm font-medium text-foreground">
                          {product.sku || 'N/A'}
                        </span>
                      </div> */}
                    </div>
                  </div>
                </div>

                {/* Right Column - Pricing and Details */}
                <div className="space-y-6">
                  {/* Pricing */}
                  <div className="bg-muted/50 rounded-lg p-6">
                    <h4 className="text-lg font-semibold text-foreground mb-4">Pricing</h4>
                    
                    <div className="space-y-3">
                      <div className="flex items-center justify-between">
                        <span className="text-muted-foreground"> Price:</span>
                        <span className="text-2xl font-bold text-foreground">
                          ${product?.price?.toFixed(2)}
                        </span>
                      </div>
                      
                      {/* {product.originalPrice && product.originalPrice > product.price && (
                        <>
                          <div className="flex items-center justify-between">
                            <span className="text-muted-foreground">Original Price:</span>
                            <span className="text-lg text-muted-foreground line-through">
                              ${product.originalPrice.toFixed(2)}
                            </span>
                          </div>
                          
                          <div className="flex items-center justify-between">
                            <span className="text-muted-foreground">Discount:</span>
                            <span className="text-lg font-semibold text-success">
                              {Math.round(((product.originalPrice - product.price) / product.originalPrice) * 100)}% OFF
                            </span>
                          </div>
                        </>
                      )} */}
                    </div>
                  </div>

                  {/* Inventory */}
                  {/* <div className="bg-muted/50 rounded-lg p-6">
                    <h4 className="text-lg font-semibold text-foreground mb-4">Inventory</h4>
                    
                    <div className="space-y-3">
                      <div className="flex items-center justify-between">
                        <span className="text-muted-foreground">Stock Quantity:</span>
                        <div className="flex items-center space-x-2">
                          <Icon name={inventoryStatus.icon} size={16} className={inventoryStatus.color} />
                          <span className="font-semibold text-foreground">
                            {product.inventory} units
                          </span>
                        </div>
                      </div>
                      
                      <div className="flex items-center justify-between">
                        <span className="text-muted-foreground">Status:</span>
                        <span className={`font-medium ${inventoryStatus.color}`}>
                          {inventoryStatus.text}
                        </span>
                      </div>
                      
                      {product.trackInventory && (
                        <div className="flex items-center justify-between">
                          <span className="text-muted-foreground">Inventory Tracking:</span>
                          <div className="flex items-center space-x-1">
                            <Icon name="CheckCircle" size={16} className="text-success" />
                            <span className="text-sm text-success">Enabled</span>
                          </div>
                        </div>
                      )}
                      
                      {product.allowBackorders && (
                        <div className="flex items-center justify-between">
                          <span className="text-muted-foreground">Backorders:</span>
                          <div className="flex items-center space-x-1">
                            <Icon name="CheckCircle" size={16} className="text-success" />
                            <span className="text-sm text-success">Allowed</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div> */}

                  {/* Metadata */}
                  <div className="bg-muted/50 rounded-lg p-6">
                    <h4 className="text-lg font-semibold text-foreground mb-4">Information</h4>
                    
                    <div className="space-y-3">
                      {/* <div className="flex items-center justify-between">
                        <span className="text-muted-foreground">Created:</span>
                        <span className="text-sm text-foreground">
                          {product.createdAt ? formatDate(product.createdAt) : 'N/A'}
                        </span>
                      </div>
                      
                      <div className="flex items-center justify-between">
                        <span className="text-muted-foreground">Last Updated:</span>
                        <span className="text-sm text-foreground">
                          {product.updatedAt ? formatDate(product.updatedAt) : 'N/A'}
                        </span>
                      </div> */}
                      
                      <div className="flex items-center justify-between">
                        <span className="text-muted-foreground">Product ID:</span>
                        <span className="text-sm font-mono text-foreground">
                          #{product?._id}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="flex items-center justify-end space-x-3 p-6 border-t border-border bg-muted/30">
            <Button
              variant="outline"
              onClick={onClose}
            >
              Close
            </Button>
            <Button
              onClick={() => {
                onEdit(product);
                onClose();
              }}
              iconName="Edit"
              iconPosition="left"
              iconSize={16}
            >
              Edit Product
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsModal;